var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content account timelimits-container" },
    [
      _vm.accountSummaryFlow
        ? _c("h1", [_vm._v(_vm._s(_vm.$t("Account.PlayLimits.Time")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.timeLimits
        ? _c(
            "div",
            {
              staticClass: "temp play-limits ctsform",
              class: { "tl-not-in-popup": !_vm.isOnRegistration }
            },
            [
              !_vm.accountSummaryFlow
                ? _c("h1", [_vm._v(_vm._s(_vm.$t("Account.PlayLimits.Time")))])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "play-limits-container perday" }, [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("Account.PlayLimits.Time.Daily")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "limit__info" }, [
                  _c("span", { key: "pl_dpdm_err" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Account.PlayLimits.Time.DepositPerDay.Msg")
                      )
                    )
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _vm.maxDailyLimit
                    ? _c("span", {
                        key: "mdtl",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("Account.PlayLimits.Time.MaxDaily", {
                              mdl: _vm.maxDailyLimit / 60
                            })
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.maxDailyLimit
                    ? _c("span", { key: "mdtlns" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("Account.PlayLimits.Time.MaxDaily.NotSet")
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dailyLimit === null &&
                  _vm.pendingDailyLimit === null &&
                  _vm.pendingLimitActivationTime === null
                    ? _c(
                        "span",
                        {
                          key: "dtlns",
                          staticClass: "current-limit-info acc_infomsg_default"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Account.PlayLimits.Time.Daily.NotSet")
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.dailyLimit === 1
                  ? _c("span", {
                      key: "dtl",
                      staticClass: "current-limit-info acc_infomsg_default",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("Account.PlayLimits.Time.Daily.Current.One", {
                            cdtl: _vm.dailyLimit
                          })
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.dailyLimit > 1
                  ? _c("span", {
                      key: "dtlm",
                      staticClass: "current-limit-info acc_infomsg_default",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("Account.PlayLimits.Time.Daily.Current", {
                            cdtl: _vm.dailyLimit
                          })
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.pendingDailyLimit
                  ? _c("span", {
                      key: "dtlpl",
                      staticClass: "pending-limit-info",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("Account.PlayLimits.Time.Daily.Pending", {
                            pdtl: _vm.pendingDailyLimit
                          })
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.dailyLimit &&
                _vm.pendingDailyLimit === null &&
                _vm.pendingLimitActivationTime
                  ? _c(
                      "span",
                      { key: "dtlpld", staticClass: "pending-limit-info" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "Account.PlayLimits.Time.Daily.PendingDisableLimit"
                            )
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control-block",
                    class: {
                      filled:
                        [0, undefined].indexOf(_vm.currentDailyLimit) === -1
                    }
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentDailyLimit,
                            expression: "currentDailyLimit"
                          }
                        ],
                        staticClass: "input-field",
                        attrs: { id: "dailyLimit", autocomplete: "off" },
                        on: {
                          focusout: function($event) {
                            _vm.currentDailyLimit === undefined
                              ? (_vm.errorMessages.dailyTimeLimitMissing = true)
                              : (_vm.errorMessages.dailyTimeLimitMissing = false)
                          },
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.currentDailyLimit = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.dailyTimelimitHours, function(hour, i) {
                        return _c(
                          "option",
                          { key: i, domProps: { value: hour } },
                          [_vm._v(_vm._s(hour))]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      { key: "pl_dpd_label", staticClass: "control-label" },
                      [_vm._v(_vm._s(_vm.$t("Account.PlayLimits.Time.Hours")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "save-button-container form-actions" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "transactions primary-btn",
                        attrs: {
                          disabled:
                            !_vm.allowAccountUpdate || !_vm.currentDailyLimit,
                          id: "btn_setDailyLimit",
                          color: "success",
                          "x-large": ""
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.setLimit("day")
                          }
                        }
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("Account.Save")))])]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isOnRegistration
        ? _c(
            "ProcessingDialog",
            {
              attrs: {
                isDialogPersistent: true,
                isProcessing: _vm.isProcessing,
                isSuccess: !_vm.transactionError,
                processingTitle: _vm.$t(
                  "Account.PersonalDetails.Dialog.Processing.Title"
                ),
                processingText: _vm.$t(
                  "Account.PersonalDetails.Dialog.Processing.Text"
                ),
                successTitle: _vm.$t("Account.PlayLimits.Dialog.Success.Title"),
                successText: _vm.$t("Account.PlayLimits.Dialog.Success.Text"),
                errorTitle: _vm.$t("Account.PlayLimits.Dialog.Error.Title"),
                closeBtnText: _vm.$t("ProcessingDialog.CloseButtonText")
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
                _vm.brandKey !== "sb"
                  ? _c(
                      "p",
                      { staticClass: "generic-icon-note" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-1", attrs: { color: "error" } },
                          [_vm._v("error")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("Account.Join.Dialog.Error.Text"))
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "response-error" }, [
                  _vm._v(_vm._s(_vm.transactionError))
                ]),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "Account.PlayLimits.Dialog.Error.Text.ContactSupport"
                      )
                    )
                  }
                })
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11a81ac6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11a81ac6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountTimeLimitsComponent.vue
// module id = null
// module chunks = 